export const EMBEDDED_DRAWIO_EDITOR_URL =
  '/editor/?spin=1&embed=1&proto=json&pv=0&configure=1';
export const EMBEDDED_DRAWIO_VIEWER_URL =
  '/editor/?spin=1&embed=1&proto=json&chrome=0&toolbar=0&configure=1&grid=1';
